if(!window.theme._registeredSections['about-us'] === true){
  theme.aboutUs = (function() {

    function aboutUs(container) {

      $('.our-journey__years').on('init', function() {
        $(this).css({visibility: 'visible'});
      });

      $('.our-journey__years-content').on('init', function() {
        $(this).css({visibility: 'visible'});
      });

      $('.our-journey__years').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '60px',
        arrows: true,
        dots: false,
        focusOnSelect: true,
        asNavFor: '.our-journey__years-content',
        rows: 0,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '80px',
              arrows: true,
              dots: false,
              focusOnSelect: true,
              asNavFor: '.our-journey__years-content',
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '30px',
              arrows: true,
              dots: false,
              focusOnSelect: true,
              asNavFor: '.our-journey__years-content',
            },
          },
        ],
      });

      $('.our-journey__years-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerPadding: '100px',
        dots: false,
        fade: true,
        asNavFor: '.our-journey__years',
        rows: 0,
      });

    }

    return aboutUs;

  })();
  window.theme.sections.register('about-us', theme.aboutUs);
  window.theme._registeredSections['about-us'] = true;
}
